import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { ConsultaAtendimentosRequest, Types } from './types';

// ACTIONS
import {
	consultaAtendimentosSuccess,
	consultaAtendimentosFailure,
} from './actions';

function* consultaAtendimentosRequest(request: ReducerAction) {
	const { payload }: { payload: ConsultaAtendimentosRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos/${CHANNEL}/atendimentos`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultaAtendimentosSuccess(response));
	} else {
		yield put(consultaAtendimentosFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTA_ATENDIMENTOS_REQUEST, consultaAtendimentosRequest),
]);
